<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New Cancellation Reason</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <cancellation-reasons-form
					:reason="tempReason" :reasonTypesOptions="getReasonTypesOptions"
					@canSaveReason="canSaveReason = $event"
				></cancellation-reasons-form>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import cancellationReasonsForm from './cancellationReasonsForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempReason: null,
				defaultReason: {
					description: "",
					reasonType: 0
				},
				canSaveReason: false,
            }
        },
        created: function() {
            this.tempReason = JSON.parse(JSON.stringify(this.defaultReason))
        },
        computed: {
            ...mapGetters([
				'getReasonTypesOptions',
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createReason'
            ]),
            save: function() {
				if(!this.canSaveReason) {
					this.$toasted.error('Please fill in all required fields');
					return
				}
				console.log('this.tempReason :>> ', this.tempReason);
                this.createReason(this.tempReason).then(
                    this.close()
                )
            },
            close: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            cancellationReasonsForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// createCancellationReason.vue?6bfde7a0